export default __webpack_public_path__ + "static/media/LeftArrow.02b7c1b1.svg";